import { SimpleLinkField } from 'framework/ViewTypes';
import { Typography } from '@mui/material';
import type { FlatListTableProps, ListTableColumn } from 'framework/ui/ui-builder';
import { applicationMenuActions, applicationRowActions } from './applicationRowActions';
import { emptyValue } from '../shared/constants';
import { getTimeInStage } from './timeInStageHelper';
import type { ApplicationRow } from '../shared/types';

const getColumns = (getDetailsUrl: (id: number) => string): ListTableColumn<ApplicationRow>[] => [
  {
    id: 'candidateName',
    label: 'Candidate name',
    render: row => <SimpleLinkField to={getDetailsUrl(row.id)} value={row.candidateName} />,
  },
  { id: 'specialization', label: 'Specialization', width: 170, render: row => row.specialization, sortable: true },
  { id: 'technology', label: 'Technology', render: row => row.technology, sortable: true },
  { id: 'level', label: 'Level', width: 110, render: row => row.level, sortable: true },
  { id: 'stage', label: 'State', width: 120, render: row => row.stage, sortable: true },
  { id: 'stageStatus', label: 'State Status', render: row => row.stageStatus, sortable: true },
  { id: 'stateOwner', label: 'State Owner', render: row => row.stateOwner, sortable: true },
  {
    id: 'timeInStage',
    label: 'Time in Stage',
    sortable: true,
    render: row => {
      const { label, color } = getTimeInStage(row.createdAt);

      return (
        <Typography component="span" color={color}>
          {label}
        </Typography>
      );
    },
  },
  {
    id: 'pool',
    label: 'Recruiting Pool',
    sortable: true,
    width: 180,
    render: row => row.pool.name || emptyValue,
  },
];

const actionsColumnSx = {
  'th:last-of-type, td:last-of-type': {
    textAlign: 'left',
    '& > div': { justifyContent: 'flex-start' },
    '& .MuiIconButton-root[aria-label^="More actions"]': { width: 26, height: 26, color: 'primary.main' },
  },
};

interface ApplicationsTableConfigParams {
  rows: ApplicationRow[];
  getDetailsUrl: (id: number) => string;
}

export const getApplicationsTableConfig = ({
  rows,
  getDetailsUrl,
}: ApplicationsTableConfigParams): FlatListTableProps<ApplicationRow> => ({
  rows,
  columns: getColumns(getDetailsUrl),
  rowActions: { actions: applicationRowActions },
  menuActions: applicationMenuActions,
  sx: actionsColumnSx,
  emptyContent: 'No applications found.',
});
